import { Outlet, useLocation } from 'react-router-dom';

import { isComingSoonRoute } from 'config/coming-soon';
import ComingSoonPage from 'pages/coming-soon/coming-soon';

/**
 * Renders ComingSoonPage when the current URL is listed in
 * `src/config/coming-soon/config.ts`; otherwise renders nested routes.
 */
export function ComingSoonRouteGuard() {
  const { pathname } = useLocation();

  if (isComingSoonRoute(pathname)) {
    return <ComingSoonPage />;
  }

  return <Outlet />;
}
